<template>
    <section
        v-editable="blok"
        class="team-section"
    >
        <KSectionHeader
            v-if="blok.badge || blok.title || blok.subtitle"
            class="team-section__header"
            :eyebrow="blok.badge"
            :title="blok.title"
            :text="blok.subtitle"
            :align="blok.align || 'start'"
        >
            <template
                v-if="blok.action_label && (blok.action_link?.url || blok.action_link?.email || blok.action_link?.cached_url || blok.action_link?.anchor)"
                #actions
            >
                <StoryblokSectionHeaderAction
                    :label="blok.action_label"
                    :link="blok.action_link"
                    placement="team-section"
                />
            </template>
        </KSectionHeader>

        <div
            v-if="blok.members?.length"
            class="team-section__grid"
        >
            <team-member
                v-for="member in blok.members"
                :key="member._uid"
                :blok="member"
            />
        </div>
    </section>
</template>

<script setup>
import { KSectionHeader } from '@vemedia/karibu'

const { blok } = defineProps(['blok'])
</script>

<style lang="scss">
@use 'team-section';
</style>
